export const WAVE_PHONE_NUMBER = "85258";
